import React from 'react'

import MerchantSelect from '@components/operator/MerchantSelect'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import { useSingleNotification } from '@hooks/operator/useBackgroundJobNotification'
import PageHeader from '@shared/PageHeader'
import SluggishProductsPage from '@shared/sluggish_products/SluggishProductsPage'

import { sluggishProductService } from '@services/operator/sluggishProductService'

function SluggishProductsContent() {
  const { addJob } = useOperatorNotification()
  const { merchantId } = useOperatorData()

  return (
    <div>
      <PageHeader items={['products', 'products.sluggish']} />
      <SluggishProductsPage
        role="operator"
        service={sluggishProductService}
        addJob={addJob}
        useSingleNotification={useSingleNotification}
        selectedMerchantId={merchantId}
      />
    </div>
  )
}

export default function OperatorSluggishProductsIndex() {
  return (
    <MerchantSelect>
      <SluggishProductsContent />
    </MerchantSelect>
  )
}
